module.exports = __webpack_public_path__ + "static/img/2-3-12.2fe37aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serviceContent/2-3-12.jpg
// module id = O2X3
// module chunks = 1